// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"4c4095ca","21":"a32e7485","27":"28c4e9f2","97":"ee53ca63","222":"6458eff7","249":"c49a7ace","432":"181de6d2","448":"9bb6a0f7","592":"8ce5054c"}[chunkId] + ".chunk.js";
};